import { skipToken, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { SiteSetupProcessRaw } from "../SiteSetupAssistant.types";

function useSiteSetupAssistant(processId?: string) {
  const {
    isLoading: siteSetupAssistantLoading,
    error: siteSetupAssistantError,
    data: formData
  } = useQuery({
    queryKey: ["siteSetupAssistant", { processId }],
    queryFn: processId ? () => fetchSiteSetupAssistant(processId) : skipToken
  });

  return {
    isLoading: siteSetupAssistantLoading,
    error: siteSetupAssistantError,
    data: formData
  };
}

async function fetchSiteSetupAssistant(processId: string) {
  const response = await apiWithoutCamelization.get<SiteSetupProcessRaw>(
    urls.apiWithoutCamelization.siteSetupAssistant.mieterStromData(processId)
  );
  return response.data;
}

export { useSiteSetupAssistant };
